<template>
  <v-container class="margen_paginas pt-7" fluid>

    <TablaDatosAPI
      ref="tabla"
      :titulo="$t ('Estado de cargadores')"
      icono="mdi-gauge"
      tabla="v_estcar"
      :campos="['id_car-', 'codins-', 'id_ins', 'numcarins', 'des', 'cod-', 'dis', 'id_estcar', 'desest-', 'ultest-', 'cargesext', 'coderr-', 'deserr-', 'traact-', 'inicar', 'fincar-', 'kwhcar-', 'coscar', 'id_apicar-']"
      :campos-filtrables="['id_ins', 'inicar', 'fincar']"
      busqueda-rapida
      :segundos-auto-refresco="5"
      accionesPersonalizadas
      :item-class="obtenerItemClassTablaDatos"
    >
      <template v-slot:accionesPersonalizadas="{item}">
        <v-icon small color="primary" class="mr-2" @click="activarCargador (item)">mdi-play</v-icon>
        <v-icon small color="primary" class="mr-2" @click="desactivarCargador (item)">mdi-stop</v-icon>
      </template>
    </TablaDatosAPI>

  </v-container>
</template>

<script>
import TablaDatosAPI from "@/components/TablaDatosAPI.vue";
import api from "@/api";

export default {
  components: { TablaDatosAPI },
  computed: {
    permisoEscritura() {
      return this.$store.operador.atributosRol.includes ("gescar");
    }
  },
  methods: {
    activarCargador (estadoCargador) {
      api.activarCargador ({
        codigo_instalacion: estadoCargador.codins,
        numero_cargador: estadoCargador.numcarins
      })
      this.$refs.tabla.actualizarDatos();
    },
    desactivarCargador (estadoCargador) {
      api.desactivarCargador ({
        codigo_instalacion: estadoCargador.codins,
        numero_cargador: estadoCargador.numcarins
      })
      this.$refs.tabla.actualizarDatos();
    },
    obtenerItemClassTablaDatos (item) {
      if (item.id_estcar == 50)
        return "cargando";
      else if (item.id_estcar == 30 || item.id_estcar == 60)
        return "pendiente";
      else
        return "disponible";
    },
  }
};
</script>

<style>
  .disponible {
  }
  .cargando {
    color: #3639ff;
    font-weight: 800;
  }
  .pendiente {
    color: #689F38;
  }
</style>